import { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Route } from 'react-router-dom';
import { KoobPageHeader, KoobSettingsModal } from '@koob/ui';
import { useApp } from 'hooks';
import { decodeId } from 'utils';
import RequireActingOrganization from 'components/RequireActingOrganization';
import KoobLayout from 'components/Koob/KoobLayout';
import NotificationPreferences from 'containers/Profile/NotificationPreferences';
import { settingsSections } from 'components/settingsSections';

const AuditLog = lazy(() => import('containers/AuditLog'));
const TravelDiarySettings = lazy(
  () => import('containers/TravelDiarySettings'),
);
const TravelDiaryContentLibrary = lazy(
  () => import('containers/TravelDiaryContentLibrary'),
);

function Notifications() {
  const { t } = useTranslation('mainSidebar');
  const { user } = useApp();

  return (
    <KoobLayout
      header={<KoobPageHeader title={t('settingsModal.notifications')} />}
    >
      <NotificationPreferences userId={decodeId(user?.id)} />
    </KoobLayout>
  );
}

/**
 * TO's settings modal: its pages keep their URLs; App.js renders them here,
 * over the last page, and onClose goes back to it. Inside, KoobLayout draws
 * the page's header and content only.
 */
export default function SettingsModal({ open, onClose }) {
  const { t } = useTranslation('mainSidebar');
  const { user, isAllowedTo, currentUserRole } = useApp();

  return (
    <KoobSettingsModal
      open={open}
      groups={settingsSections(t, isAllowedTo, currentUserRole)}
      user={{
        name: user?.firstName
          ? `${user.firstName} ${user.lastName || ''}`
          : user?.email,
        email: user?.email,
      }}
      onClose={onClose}
    >
      <Route path="user/notification-preferences" element={<Notifications />} />
      <Route path="audit-log" element={<AuditLog />} />
      <Route
        path="travel-diary-content-library/*"
        element={<TravelDiaryContentLibrary />}
      />
      <Route
        path="travel-diary-settings"
        element={
          <RequireActingOrganization>
            <TravelDiarySettings />
          </RequireActingOrganization>
        }
      />
    </KoobSettingsModal>
  );
}
